import React, { useState } from 'react'

import './styles.scss'

const VoteCard = ({ video, text, onSelect }) => {
	const [isSelected, setIsSelected] = useState(false)

	return (
		<div
			className={`vote-card ${isSelected ? 'vote-card--active' : ''}`}
			onClick={() => {
				setIsSelected(true)
				onSelect()
			}}
		>
			<div className="vote-card__wrapper">
				<video
					poster={`/images/prediction/${video}.png`}
					autoPlay="autoplay"
					loop
					muted
					src={`/videos/prediction/${video}.mp4`}
					type="video/mp4"
					className="vote-card__wrapper__video"
					playsInline
				/>
				<div className="vote-card__wrapper__shadow"></div>
			</div>
			<p className="vote-card__text">{text}</p>
		</div>
	)
}

export { VoteCard }
